<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-16">
    </v-breadcrumbs>
    <!-- <v-card> -->
    <v-row dense
           class="mx-16 justify-center">
      <v-col cols="12"
             sm="12"
             md="12"
             lg="12"
             class="mt-2">
        <v-card-title class="font-weight-bold grey lighten-2">
          TCGA Meta Information
        </v-card-title>
        <v-data-table dense
                      class="data-table-style mt-1"
                      v-model="selected"
                      :headers="headers"
                      fixed-header
                      :items="tcga_meta"
                      item-key="_id"
                      :search="search"
                      :loading="loading"
                      loading-text="Loading... Please wait"
                      :items-per-page="itemsPerPage"
                      :footer-props="{
      showFirstLastPage: true,
      firstIcon: 'mdi-page-first',
      lastIcon: 'mdi-page-last',
      'items-per-page-options':[5,10,15,20,-1] }">
          <!-- item.project_id slot -->
          <template v-slot:[`item.project_id`]="{item}">
            <a @click="goToTCGA(item.project_id)">
              <span class="font-weight-bold">{{item.project_id.split('-')[1]}}</span>
            </a>
          </template>

          <!-- item.disease_type slot -->
          <template v-slot:[`item.disease_type`]="{item}">
            <div v-show="item.disease_type.indexOf(';') !== -1">
              <span v-if="!isShowMore">
                {{item.disease_type.split('; ')[0]}}
                <a v-show="!isShowMore"
                   @click="isShowMore = !isShowMore"> More...</a>
              </span>
              <ul v-else
                  v-for="(v, i) in item.disease_type.split('; ')"
                  :key="i">
                <li>{{v}}</li>
              </ul>
              <a v-show="isShowMore"
                 @click="isShowMore=!isShowMore"> ...Less</a>
            </div>
            <div v-show="item.disease_type.indexOf(';') === -1">
              {{item.disease_type}}
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- </v-card> -->
  </v-container>
</template>

<script>
import { getTcgaMeta } from "node/projects";

export default {
  name: 'TcgaMeta',
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Projects',
          disabled: true,
        },
        {
          text: 'TCGA',
          disabled: true,
        },
      ],

      isShowMore: false,

      tcga_meta: [],

      selected: [],
      search: '',
      loading: true,
      itemsPerPage: 15,
      headers: [
        { text: 'Data Resource', value: 'data_resource', align: 'start', sortable: false, },
        { text: 'Project ID', value: 'project_id', align: 'start', sortable: true },
        { text: 'Project Name', value: 'project_name', align: 'start', sortable: true, },
        { text: 'Disease Type', value: 'disease_type', align: 'start', sortable: false, },
        { text: 'Primary Site', value: 'primary_site', align: 'start' },
        { text: 'Tumor Number', value: 'tumor_no', align: 'center', },
        { text: 'Normal Number', value: 'normal_no', align: 'center', sortable: false, },
        { text: 'Sample Number', value: 'total_no', align: 'center', sortable: false, },
      ],
    }
  },
  created() {
    this.getTcgaMeta();
  },
  watch: {
    tcga_meta(val) {
      if (val) {
        this.loading = false;
      }
    },
  },
  methods: {
    // get all TCGA meta info
    async getTcgaMeta() {
      await getTcgaMeta().then(
        data => {
          if (data) {
            // console.log(data);
            this.tcga_meta = data;
          }
        }
      ).catch(err => console.error(err))
    },
    goToTCGA(project_id) {
      this.$router.push({
        path: `/projects/tcga/${project_id}`,
      })
    }
  },
}
</script>
<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.v-card__title
  line-height: 0.5rem

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)
</style>